import { render, staticRenderFns } from "./PricingVerTwo.vue?vue&type=template&id=223f310d&scoped=true&"
import script from "./PricingVerTwo.vue?vue&type=script&lang=js&"
export * from "./PricingVerTwo.vue?vue&type=script&lang=js&"
import style0 from "./PricingVerTwo.vue?vue&type=style&index=0&id=223f310d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223f310d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCardText,VCol,VImg,VRow,VTab,VTabItem,VTabs,VTabsItems})
